export const CHECK_AUTH = "checkAuth";
export const LOGIN = "login";
export const LOGIN_SHOPIFY = "loginShopify";
export const LOGIN_WOO = "loginWoo"
export const RELOGIN_SHOPIFY = "reloginShopify";
export const SAVE_SHOPIFY_TOKEN = "saveShopifyToken";
export const REGISTER = "register";
export const LOGOUT = "logout";
export const REMOVE_ERRORS = "removeErrors";

//shop actions
export const ASSIGN_SHOP_TYPE = "assignShopType";
export const REGISTER_SHOP_TYPE = "registerShopType";
export const REGISTER_SHOP = "registerShop";
export const LOAD_CONNECTED_SHOPS = "loadConnectedShops";
export const LOAD_CURRENT_STORE_INVENTORIES = "loadCurrentStoreInventories";
export const LOAD_CONNECTED_SHOPS_BY_URL = "loadConnectedShopsByUrl";

// Product Module Actions
export const ADD_PRODUCT_ACTION_STATUS = "addProductActionStatus";
export const FETCH_PRODUCTS_LIST = "fetchProductsList";
export const FETCH_PRODUCTS_BY_URL = "fetchProductsByUrl";

// Processing Queue Module
export const ADD_ACTION = "addAction";
export const GET_NEXT_ACTION = "getNextAction";

// Notification Module
export const ADD_NOTIFICATION = "addNotification";
export const DESTROY_NOTIFICATION = "destroyNotification";
export const CLEAN_LIST = "cleanList";
export const DESTROY_NOTIFICATION_BY_ID = "destroyNotificationById";

// Product Sync Configs Module
export const RESET_CURRENT_CONFIGS = "resetCurrentConfigs";
export const FORMAT_AND_SET_CURRENT_CONFIGS = "formatAndSetCurrentConfigs";
export const LOAD_CURRENT_CONFIGURATIONS = "loadCurrentConfigurations";
export const UPDATE_CURRENT_CONFIGURATIONS = "updateCurrentConfigurations";

//Orders
export const FETCH_ORDERS = "fetchOrders";
export const FETCH_CURRENT_ORDER = "fetchCurrentOrder";
export const HIDE_SINGLE_ORDER = "hideSingleOrder";
export const PUSH_ORDER_TO_TARGET_STORE = "pushOrderToTargetStore";
export const AUTO_PUSH_TOGGLE = "autoPushToggle";
export const FETCH_PUSH_SETTINGS = "fetchPushSettings";
export const LAUNCH_STORE_ORDER_PUSHING_STATUS = "launchStoreOrderPushingStatus";
export const FETCH_ORDERS_LIST = "fetchOrdersList";

//Plans Management
export const SAVE_PLAN = "savePlan";

//Activity Logs
export const FETCH_ACTIVITYLOG_LIST = "fetchActivityLogList";
export const FETCH_ACTIVITY_LOGS_BY_URL = "fetchActivityLogsByUrl";
export const LOAD_AVAILABLE_TYPES = "loadAvailableTypes";
